export default "__VITE_ASSET__g2haYCrq__"